import { Component, EventEmitter, OnDestroy, OnInit, Output } from '@angular/core';

import { getAllRoyalMarketLocations } from '../../constants/locations.constant';
import { Location } from '../../models/location.model';
import { MatCardModule } from '@angular/material/card';
import { UserSettingsService } from 'src/app/services/user-settings/user-settings.service';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-locations-legend',
  imports: [MatCardModule, MatButtonModule, MatIconModule, MatTooltipModule],
  templateUrl: './locations-legend.component.html',
  styleUrls: ['./locations-legend.component.scss'],
})
export class LocationsLegendComponent implements OnInit, OnDestroy {
  cities: Location[] = getAllRoyalMarketLocations();
  selectedCities: Location[] = [];
  disableSaveButton: boolean = false;
  subscriptions: Subscription[] = [];

  constructor(private userSettingsService: UserSettingsService) {}

  ngOnInit(): void {
    this.subscriptions.push(
      this.userSettingsService.userSelectedCities$.subscribe((selectedCities) => {
        this.selectedCities = selectedCities;
      })
    );
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((subscription) => subscription.unsubscribe());
  }

  onCityClicked(city: Location): void {
    this.userSettingsService.toggleUserSelectedCity(city);
  }

  saveSelectedCities(): void {
    this.disableSaveButton = true;
    this.userSettingsService.updateUserSelectedCities();
    setTimeout(() => {
      this.disableSaveButton = false;
    }, 5000);
  }
}
